import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';
export const VideoBox = t0 => {
  const $ = _c(13);
  const {
    videoUrl
  } = t0;
  const videoRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isInView = useInView(videoRef, t1);
  let t2;
  let t3;
  if ($[1] !== isInView) {
    t2 = () => {
      if (isInView) {
        videoRef.current?.play();
      }
    };
    t3 = [isInView];
    $[1] = isInView;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== videoUrl) {
    t4 = videoUrl.replace(".mp4", ".webm");
    $[4] = videoUrl;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const webmUrl = t4;
  let t5;
  if ($[6] !== webmUrl) {
    t5 = <source src={webmUrl} type="video/webm" />;
    $[6] = webmUrl;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== videoUrl) {
    t6 = <source src={videoUrl} type="video/mp4" />;
    $[8] = videoUrl;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <video preload="none" muted={true} loop={true} playsInline={true} ref={videoRef} className="rounded-3xl">{t5}{t6}Your browser does not support the video tag.</video>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};